module.exports = __webpack_public_path__ + "static/blog19-633fd8eea15e220f3373a84003748fe1.png";